import { Injectable } from "@angular/core";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { idNameItem } from "./jkInterface";


@Injectable({
  providedIn: 'root'
})
export class JkExcelService {

  constructor() {

  }
  // bookType: 'xlsx' | 'xlsm' | 'xlsb' | 'xls' | 'xla' | 'biff8' | 'biff5' | 'biff2' | 'xlml' | 'ods' | 'fods' | 'csv' | 'txt' | 'sylk' | 'slk' | 'html' | 'dif' | 'rtf' | 'prn' | 'eth' | 'dbf';
  bookTypeList: idNameItem[] = [ {"id":"xlsx","name":"Excel(xlsx)"} ,{"id":"xls","name":"Excel(xls)"} , {"id":"csv","name":".csv"} , {"id":"txt","name":"Text(.txt)"} ,
    {"id":"html","name":"html"} ,{"id":"ods","name":"ods"} ,  {"id":"dbf","name":"dbf"},
    {"id":"rtf","name":"rtf"} , {"id":"prn","name":"prn"} ,{"id":"fods","name":"fods"} ,  {"id":"sylk","name":"sylk"} , {"id":"slk","name":"slk"} ,  {"id":"dif","name":"dif"} ,  {"id":"eth","name":"eth"} ,
    {"id":"xlsm","name":"xlsm"} , {"id":"xlsb","name":"xlsb"} ,  {"id":"xla","name":"xla"} , {"id":"biff8","name":"biff8"} , {"id":"biff5","name":"biff5"} , {"id":"biff2","name":"biff2"} , {"id":"xlml","name":"xlml"}   ];

  jsonExport(jsonObj:any,fileName:string,bookType:XLSX.BookType) {
    // 將 JSON 轉換成工作表
    const worksheet = XLSX.utils.json_to_sheet(jsonObj);

    // 建立一個新的工作簿
    const workbook = XLSX.utils.book_new();

    // 將工作表新增到工作簿中
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // 將工作簿轉換成二進位數據
    const workbookBinary = XLSX.write(workbook, {
      bookType: bookType,
      type: 'array',
    });

    // 建立一個 Blob 物件
    const blob = new Blob([workbookBinary], {
      type: 'application/octet-stream',
    });

    // 觸發下載
    saveAs(blob, fileName);
  }

  jsonExportXlsx(jsonObj:any,fileName:string,headerName:string[]) {
    // 將 JSON 轉換成工作表
    const worksheet = XLSX.utils.json_to_sheet(jsonObj);

    // 設定每個欄位的標題
    XLSX.utils.sheet_add_aoa(worksheet, [headerName], { origin: 'A1' });

    // 建立一個新的工作簿
    const workbook = XLSX.utils.book_new();

    // 將工作表新增到工作簿中
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // 將工作簿轉換成二進位數據
    const workbookBinary = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    /*const csvBinary = XLSX.write(workbook, {
      bookType: 'csv',
      type: 'array',
    });*/
    // 建立一個 Blob 物件
    const blob = new Blob([workbookBinary], {
      type: 'application/octet-stream',
    });

    // 觸發下載
    saveAs(blob, fileName);
  }

}
